import palette from '../palette';

export default {
  root: {
    background: palette.primary.contrastText,
  },
};